/** @format */

export const DCSG_CONSTANTS: any = {
	analyticsReporting: {
		boolean: {
			true: 'true',
			false: 'false'
		},
		dym: {
			auto: 'DYM Auto',
			clicked: 'DYM Clicked'
		},
		pageType: {
			home: 'Home',
			category: 'Category',
			family: 'Family',
			search: 'Search',
			product: 'Product Details',
			cart: 'Cart',
			checkout: 'Checkout',
			'order.confirmation': 'OrderConfirmation'
		},
		replacementType: {
			addition: 'Addition',
			replacement: 'Replacement'
		},
		searchEmptyResults: {
			recordSetTotal: '',
			catalogEntryView: [],
			searchDetails: {
				DYMTerm: '',
				DYMType: '',
				searchTerm: '',
				replacementTerm: '',
				searchType: ''
			}
		},
		searchType: {
			keyword: 'Keyword',
			suggestedKeyword: 'Suggested Keyword',
			suggestedProduct: 'Suggested Product',
			suggestedBrand: 'Suggested Brand',
			pdpBrandClick: 'PDP Brand Click',
			suggestedResources: 'Suggested Resources',
			suggestedHistory: 'Suggested History',
			suggestedCategory: 'Suggested Category',
			searchByProductID: 'Search by ProductID',
			redirect: 'Redirect'
		},
		yesOrNo: {
			Y: 'Y',
			N: 'N'
		}
	},
	attributes: {
		identifiers: {
			badge: '4298',
			freeReturnsEligible: '4493'
		}
	},
	basePath: 'dcsg-ngx-ecommerce',
	cookies: {
		auth: {
			expiration: {
				value: 30,
				unit: 'days'
			}
		},
		cart: {
			contents: {
				cookieName: 'DCSG-CART'
			}
		},
		checkout: {
			contents: {
				cookieName: 'DCSG-CHECKOUT'
			},
			xContents: {
				cookieName: 'X-DCSG-CHECKOUT'
			}
		}
	},
	defaultCurrency: 'USD',
	defaultStoreSearchRadius: 100,
	defaultNumberOfStores: 5,
	errorHandling: {
		messagePrefixes: {
			global: {
				client: 'APPLICATION_ERROR:CLIENT_ERROR: ',
				data: 'APPLICATION_ERROR:DATA_ERROR: ',
				generic: 'APPLICATION_ERROR:GENERIC_ERROR: ',
				http: 'APPLICATION_ERROR:HTTP_ERROR: ',
				offline: 'APPLICATION_ERROR:OFFLINE_ERROR: ',
				timeout: 'TIMEOUT_ERROR: '
			}
		}
	},
	homr: {
		acceptedHeaders: [
			'dsg_range',
			'dih',
			'audience',
			'draft',
			'preview',
			'previewdate',
			'whereabouts',
			'segment'
		],
		stateKeyExceptions: [
			'banner',
			'disruptor',
			'ticker',
			'header',
			'footer',
			'deal-drawer',
			'calendar',
			'home',
			'static'
		],
		aosPageTypes: ['disruptor', 'footer', 'header', 'home', 'modal', 'ticker', 'checkout'],
		previewKey: 'williamgoats'
	},
	localStorage: {
		auth: {
			expiration: {
				value: 30,
				unit: 'days'
			}
		}
	},
	maxAppWidth: 1600,
	maxApiRetries: 3,
	paginationSize: {
		familyAndSearch: 48
	},
	productRecs: {
		timeout: 10000
	},
	searchMaxLength: 75,
	storeNumberUrl:
		'https://ngstorelocationlb.dcsg.com/NGStoreLocationWS/StoreLocationLookup.svc/json/GetStoreInformation',
	timeouts: {
		default: 20000,
		xxshort: 2000,
		xshort: 5000,
		short: 10000,
		medium: 30000,
		long: 60000
	},
	xProperties: {
		groupingLogicEnable: 'GROUPINGLOGIC_ENABLED'
	},
	baseImagePath: 'https://images.dickssportinggoods.com/marketing/',
	baseProductImagePath: 'https://dks.scene7.com/is/image/',
	imageUnavailable: 'https://images.dickssportinggoods.com/marketing/productImageUnavailable.jpg',
	imageUnavailableResized:
		'https://dks.scene7.com/is/image/GolfGalaxy/productImageUnavailable?wid=252&hei=252',
	minQtyAlert: {
		// message: 'You have selected the quantity which is less than the minimum limit for this product. The quantity has been adjusted for you.'
		message: 'The minimum quantity for this product option is'
	},

	maxQtyAlert: {
		// message: 'You have exceeded the maximum limit on the quantity for this product. The quantity has been adjusted for you.'
		message: 'The maximum quantity for this product option is'
	},
	categoryAffinity: {
		attributeIDToCategoryMap: {
			3445: 'NFL',
			6702: 'NFL'
		},
		supportedAttributes: ['NFL Team'],
		valueMap: {
			NFL: {
				'Arizona Cardinals': 'ARI_NFL',
				'Atlanta Falcons': 'ATL_NFL',
				'Baltimore Ravens': 'BAL_NFL',
				'Buffalo Bills': 'BUF_NFL',
				'Carolina Panthers': 'CAR_NFL',
				'Chicago Bears': 'CHI_NFL',
				'Cincinnati Bengals': 'CIN_NFL',
				'Cleveland Browns': 'CLE_NFL',
				'Dallas Cowboys': 'DAL_NFL',
				'Denver Broncos': 'DEN_NFL',
				'Detroit Lions': 'DET_NFL',
				'Green Bay Packers': 'GB_NFL',
				'Houston Texans': 'HOU_NFL',
				'Indianapolis Colts': 'IND_NFL',
				'Jacksonville Jaguars': 'JAC_NFL',
				'Kansas City Chiefs': 'KC_NFL',
				'Las Vegas Raiders': 'LV_NFL',
				'Los Angeles Chargers': 'LAC_NFL',
				'Los Angeles Rams': 'LA_NFL',
				'Miami Dolphins': 'MIA_NFL',
				'Minnesota Vikings': 'MIN_NFL',
				'New England Patriots': 'NE_NFL',
				'New Orleans Saints': 'NO_NFL',
				'New York Giants': 'NYG_NFL',
				'New York Jets': 'NYJ_NFL',
				'Philadelphia Eagles': 'PHI_NFL',
				'Pittsburgh Steelers': 'PIT_NFL',
				'San Francisco 49ers': 'SF_NFL',
				'Seattle Seahawks': 'SEA_NFL',
				'Tampa Bay Buccaneers': 'TB_NFL',
				'Tennessee Titans': 'TEN_NFL',
				'Washington Commanders': 'WAS_NFL'
			}
		}
	}
};
